import api from "../utils/interceptor";
const API_URL = process.env.REACT_APP_API_URL;

// Create Product Inquiry Service
export const createProductInquiryService = async (data) => {
  try {
    const response = await api.post(API_URL + "product-inquiry", data);
    return response;
  } catch (error) {
    console.error("Error creating product inquiry :", error);
    throw error;
  }
};

// Update Product Inquiry Service
export const updateProductInquiryService = async (data) => {
  try {
    const response = await api.put(
      API_URL + "product-inquiry/" + data?.id,
      data
    );
    return response;
  } catch (error) {
    console.error("Error updating product inquiry :", error);
    throw error;
  }
};
